import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Maska from 'maska'
import App from './App.vue'
import '@/scss/custom.scss'
import VueFinalModal from 'vue-final-modal'
import VModal from 'src/modules/shared/components/VModal.vue'
import SlDialogLoader from "src/modules/shared/components/Dialog/SlDialogLoader";
import SlDialogError from "src/modules/shared/components/Dialog/SlDialogError";
import SlDialog from "src/modules/shared/components/Dialog/SlDialog";
import { VueReCaptcha } from 'vue-recaptcha-v3'

// Afin de pouvoir parser correctement les dates
import dayjs from 'dayjs'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

const app = createApp(App)
app.use(VueAxios, axios)
app.use(Maska);
app.use(VueFinalModal())
app.use(VueReCaptcha, {
        siteKey: window.__NXT_FRONT_CONFIG__.VUE_APP_RECAPTCHA3_SITE_KEY,
        loaderOptions: {
            autoHideBadge: true
        }
    }
)

app.component('VModal', VModal)
app.component('SlDialogLoader', SlDialogLoader)
app.component('SlDialogError', SlDialogError)
app.component('SlDialog', SlDialog)

import directives from "./directives/";
directives(app);

app.mount('#app')
